import { render, staticRenderFns } from "./ObjectDangerOccurStatistic.vue?vue&type=template&id=3c97b7dc&"
import script from "./ObjectDangerOccurStatistic.vue?vue&type=script&lang=js&"
export * from "./ObjectDangerOccurStatistic.vue?vue&type=script&lang=js&"
import style0 from "./ObjectDangerOccurStatistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c97b7dc')) {
      api.createRecord('3c97b7dc', component.options)
    } else {
      api.reload('3c97b7dc', component.options)
    }
    module.hot.accept("./ObjectDangerOccurStatistic.vue?vue&type=template&id=3c97b7dc&", function () {
      api.rerender('3c97b7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/ObjectDangerOccurStatistic.vue"
export default component.exports